import { isDefined } from '@aloft/toolkit-shared';
import { Tooltip } from '@aloft/toolkit-sui';

import { ComponentProps, Fragment } from 'react';

export const MaybeTooltip = ({ children, ...props }: ComponentProps<typeof Tooltip>) => {
  const hasContent = isDefined(props.label);
  return hasContent ? <Tooltip {...props}>{children}</Tooltip> : <Fragment>{children}</Fragment>;
};
